<template>
    <div class="input">
        <label v-if="label">{{ label }}</label>
        <a href="#" @click.prevent="getHelp" class="help-text" v-if="helpText">{{ helpText }}</a>
        <select
            :class="inputClass"
            v-model="boundModelValue"
            :autocomplete="autocomplete"
            :disabled="disabled"
            v-on="$listeners"
        >
            <option v-if="allowNullSelection" :value="null">[None]</option>
            <option
                v-for="(option, index) in options"
                :key="option.id || option.text || index"
                :value="option.value || option"
                :disabled="option.disabled"
            >
                {{ applyFormat(option) }}
            </option>
        </select>
        <div class="input-error" v-for="(errorMessage, index) in errorMessages" :key="index">{{ errorMessage }}</div>
    </div>
</template>
<script>
export default {
    name: 'MtSelect',
    model: {
        prop: 'modelValue',
        event: 'update:modelValue',
    },
    props: {
        allowNullSelection: {
            type: Boolean,
            default: false,
        },
        options: {
            required: true,
            type: Array,
        },
        label: {
            required: false,
        },
        autocomplete: {
            required: false,
            type: String,
        },
        modelValue: {
            required: false,
        },
        disabled: {
            required: false,
            type: Boolean,
            default: false,
        },
        errorMessage: {
            type: [String, Array],
            required: false,
            default: '',
        },
        helpText: {
            type: String,
            required: false,
            default: null,
        },
        format: {
            type: Function,
            required: false,
        },
    },
    computed: {
        boundModelValue: {
            get() {
                return this.modelValue
            },
            set(v) {
                this.$emit('update:modelValue', v)
            },
        },
        inputClass() {
            return { 'has-error': !!this.errorMessage }
        },
        errorMessages() {
            if (!this.errorMessage) {
                return []
            }

            return Array.isArray(this.errorMessage) ? this.errorMessage : [this.errorMessage]
        },
    },
    methods: {
        applyFormat(option) {
            if (this.format) {
                return this.format(option)
            }

            return option.text || option
        },
        getHelp() {
            this.$emit('help')
        },
    },
}
</script>
